// Completion sound options with different musical patterns

export const playCompletionSound = (soundType = 'chord') => {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    
    switch (soundType) {
      case 'chord':
        // Original: C major chord (C5, E5, G5)
        const chordNotes = [523.25, 659.25, 783.99];
        chordNotes.forEach((frequency, index) => {
          const oscillator = audioContext.createOscillator();
          const gainNode = audioContext.createGain();
          
          oscillator.connect(gainNode);
          gainNode.connect(audioContext.destination);
          
          oscillator.frequency.value = frequency;
          oscillator.type = 'sine';
          
          const startTime = audioContext.currentTime + (index * 0.05);
          const duration = 0.4;
          
          gainNode.gain.setValueAtTime(0.4, startTime);
          gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
          
          oscillator.start(startTime);
          oscillator.stop(startTime + duration);
        });
        break;

      case 'ascending':
        // Ascending scale: C, D, E, F, G
        const ascendingNotes = [523.25, 587.33, 659.25, 698.46, 783.99];
        ascendingNotes.forEach((frequency, index) => {
          const oscillator = audioContext.createOscillator();
          const gainNode = audioContext.createGain();
          
          oscillator.connect(gainNode);
          gainNode.connect(audioContext.destination);
          
          oscillator.frequency.value = frequency;
          oscillator.type = 'sine';
          
          const startTime = audioContext.currentTime + (index * 0.08);
          const duration = 0.3;
          
          gainNode.gain.setValueAtTime(0.3, startTime);
          gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
          
          oscillator.start(startTime);
          oscillator.stop(startTime + duration);
        });
        break;

      case 'bell':
        // Bell-like sound with harmonics
        const bellFrequencies = [523.25, 1046.50, 1567.98];
        bellFrequencies.forEach((frequency, index) => {
          const oscillator = audioContext.createOscillator();
          const gainNode = audioContext.createGain();
          
          oscillator.connect(gainNode);
          gainNode.connect(audioContext.destination);
          
          oscillator.frequency.value = frequency;
          oscillator.type = index === 0 ? 'sine' : 'triangle';
          
          const startTime = audioContext.currentTime;
          const duration = 0.6;
          
          const volume = index === 0 ? 0.4 : 0.2;
          gainNode.gain.setValueAtTime(volume, startTime);
          gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
          
          oscillator.start(startTime);
          oscillator.stop(startTime + duration);
        });
        break;

      case 'pop':
        // Quick pop sound
        const popNotes = [880, 1108.73]; // A5, C#6
        popNotes.forEach((frequency, index) => {
          const oscillator = audioContext.createOscillator();
          const gainNode = audioContext.createGain();
          
          oscillator.connect(gainNode);
          gainNode.connect(audioContext.destination);
          
          oscillator.frequency.value = frequency;
          oscillator.type = 'square';
          
          const startTime = audioContext.currentTime + (index * 0.03);
          const duration = 0.15;
          
          gainNode.gain.setValueAtTime(0.5, startTime);
          gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
          
          oscillator.start(startTime);
          oscillator.stop(startTime + duration);
        });
        break;

      case 'gentle':
        // Gentle single note with fade
        const gentleFrequency = 659.25; // E5
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);
        
        oscillator.frequency.value = gentleFrequency;
        oscillator.type = 'sine';
        
        const startTime = audioContext.currentTime;
        const duration = 0.5;
        
        gainNode.gain.setValueAtTime(0.3, startTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
        
        oscillator.start(startTime);
        oscillator.stop(startTime + duration);
        break;

      default:
        // Default to chord
        playCompletionSound('chord');
    }
  } catch (error) {
    // Sound not supported or user has disabled audio
    console.log('Audio context not available');
  }
};

export const soundOptions = [
  { value: 'chord', label: 'Chord', description: 'Harmonious chord (default)' },
  { value: 'ascending', label: 'Ascending', description: 'Rising scale' },
  { value: 'bell', label: 'Bell', description: 'Bell-like chime' },
  { value: 'pop', label: 'Pop', description: 'Quick pop sound' },
  { value: 'gentle', label: 'Gentle', description: 'Soft single note' },
];

